import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { menuActive } from '../../store/menuSlice'
import { NewsPubilc } from 'pages/News'

function HealthNews() {
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(menuActive('ข่าวสารสุขภาพ'))
    }, [])

    return (
        <>
            <NewsPubilc />
        </>
    )
}

export default HealthNews
